import isArray from 'lodash/isArray';

type NamedObject = {
  name: string;
};

export const getUniqueName = (
  prefix: string,
  arg: NamedObject[] | ((name: string) => boolean),
): string => {
  const exists = isArray(arg) ? (name: string) => arg.some(n => n.name !== name) : arg;
  let name = prefix;
  for (let suffix = 1; exists(name); suffix += 1) {
    name = `${prefix} ${suffix}`;
  }
  return name;
};
